import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconStyle0 = cosmosIconCss;

const CosmosIcon$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIcon extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f7fb49e0a06387b5cc946cbb5bcaac0fe02b60b2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("slot", { key: '81008b574c7eaed1d097e97207ff63de810af293' })));
    }
    static get style() { return CosmosIconStyle0; }
}, [1, "cosmos-icon", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIcon$1);
            }
            break;
    } });
}

const CosmosIcon = CosmosIcon$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIcon, defineCustomElement };
